import React, { useState } from "react";
import { Button, Spin } from "antd";
import { WizardProgress } from "../components/WizardProgress";
import { ReviewMappingStep2 } from "./ReviewMappingStep2";
import { ReviewMappingStep3 } from "./ReviewMappingStep3";
import { MappingComplete } from "../components/MappingComplete";
import { MappingChange, PropertyGroups, TenantMapping } from "../Mapping";

interface ReviewMappingContainerProps {
  tenantInfo: TenantMapping;
  handleBackToSettings: () => void;
  handleBackToHome: () => void;
  venzaProperties: PropertyGroups[],
  initialData: MappingChange[];
}

const REVIEW_STEPS = [
  { number: 1, title: "Review Changes" },
  { number: 2, title: "Confirm & Save" },
];

export const ReviewMappingContainer: React.FC<ReviewMappingContainerProps> = ({
  tenantInfo,
  handleBackToSettings,
  handleBackToHome,
  initialData,
  venzaProperties,
}) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [mappingCount, setMappingCount] = useState<number>(0);
  const [previousChanges, setPreviousChanges] = useState<MappingChange[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReviewStep1Next = (prevChanges: MappingChange[]) => {
    setCurrentStep(2);
    setPreviousChanges(prevChanges);
  };

  const handleReviewConfirm = (count: number) => {
    setCurrentStep(3);
    setMappingCount(count);
  };

  if (currentStep === 3) {
    return (
      <div >
        <div className="d-flex justify-end mbx-16">
          <Button
            type="text"
            className="backToMappingSettings"
            onClick={handleBackToSettings}
          >
            ← Back to Mapping Settings
          </Button>
        </div>

        <MappingComplete
          tenantInfo={tenantInfo}
          mappingCount={mappingCount}
          onBackToHome={handleBackToHome}
        />
      </div>
    );
  }

  return (
    <Spin spinning={isSubmitting}>
    <div className="mx-auto mw-896">
      <div className="d-flex justify-end mbx-16">
        <Button
          type="text"
          className="backToMappingSettings"
          onClick={handleBackToSettings}
        >
          ← Back to Mapping Settings
        </Button>
      </div>

      <div
        className="mb-8"
      >
        <h1
          className="lh-15 fs-15 fw-500"
        >
          Review Property Mapping
        </h1>
        <p className="text-muted-foreground fw-200 fs-1">
          Review and update existing property mappings for your organization.
        </p>
      </div>

      <WizardProgress currentStep={currentStep} steps={REVIEW_STEPS} />

      {currentStep === 1 && (
        <ReviewMappingStep2
          tenantInfo={tenantInfo}
          initialData={previousChanges.length > 0 ? previousChanges : initialData}
          unChangedData={initialData}
          venzaProperties={venzaProperties}
          onNext={handleReviewStep1Next}
          onBack={handleBackToSettings}
        />
      )}

      {currentStep === 2 && (
        <ReviewMappingStep3
          tenantInfo={tenantInfo}
          initialData={initialData.filter(e => e.id !== "add-row")}
          mappedchanges={previousChanges.filter(e => e.id !== "add-row")}
          onConfirm={handleReviewConfirm}
          backToSettings={handleBackToSettings}
          onBack={() => setCurrentStep(1)}
          setIsSubmitting={setIsSubmitting}
        />
      )}
    </div>
    </Spin>
  );
};

export default ReviewMappingContainer;
